import { LoanApiService } from './../../services/loan-api.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PosConfigResolverService implements Resolve<any> {
  constructor(private loanApiService: LoanApiService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.loanApiService.getPosConfig().pipe(
      map((data) => {
        return data;
      })
    );
  }
}
